import React from "react";
import { Container, Row, Col, Image } from "react-bootstrap";
import heroImage from "../../assets/images/hero.webp";
import "../../assets/styles/glowOnHover.css";
import "../../assets/styles/fonts.css";
import RainbowButton from "../shared/RainbowButton";
import "./Hero.css"; // For the responsive styling

export default function Hero() {
  return (
    <Container
      fluid
      className="p-0 position-relative hero-container"
      style={{ height: "100vh", minHeight: "600px" }}
    >
      <Row className="h-100 m-0">
        <Col xs={12} className="p-0 position-relative">
          {/* Hero Background Image */}
          <Image
            src={heroImage}
            alt="Hero Background"
            className="position-absolute w-100 h-100 hero-image"
            style={{
              objectFit: "cover",
              top: 0,
              left: 0,
              zIndex: 0,
            }}
          />

          {/* Modern Gradient Overlay */}
          <div className="hero-gradient-overlay"></div>

          {/* Overlay Content */}
          <div className="hero-overlay">
            <div className="hero-content">
              <div className="hero-text-container">
                <p className="hero-welcome-text">Welcome To</p>
                <h1 className="hero-main-title">
                  The Style <span className="hero-title-accent">Emporium</span>
                </h1>
                <p className="hero-subtitle">
                  Where creativity meets craftsmanship
                </p>
              </div>
              <div className="hero-cta-container">
                <RainbowButton
                  text="Book Your Appointment"
                  href="https://styleemporium.glossgenius.com/booking-flow"
                />
              </div>
            </div>
          </div>
        </Col>
      </Row>
    </Container>
  );
}
